var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4648 30H8.46484V28.73L15.6048 16.5L17.3248 17.5C9.46484 31 10.4648 29 10.4648 30Z",
    fill: "#FF613D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46484 31H11.4648V30L10.4648 29H8.46484L7.46484 30V31Z",
    fill: "#F02C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4655 30H22.4655C22.4655 29 23.4655 31 15.6055 17.5L17.3255 16.5L24.4655 28.73V30Z",
    fill: "#FF613D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4648 17H15.4648V29H17.4648V17Z",
    fill: "#FF613D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4648 31H14.4648V30L15.4648 29H17.4648L18.4648 30V31Z",
    fill: "#F02C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4648 31H21.4648V30L22.4648 29H24.4648L25.4648 30V31Z",
    fill: "#F02C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21617 17.2197L1.4668 18.2297L4.4918 23.4692L6.24117 22.4592L3.21617 17.2197Z",
    fill: "#FF613D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.263 0.997325L23.5137 2.00732L29.5587 12.4776L31.308 11.4676L25.263 0.997325Z",
    fill: "#FFC9BD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0542 11.6099L10.5942 19.9399L7.57422 14.6999L24.0142 2.87988L29.0542 11.6099Z",
    fill: "#FFC9BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07961 15.5801L3.71484 18.1001L5.72984 21.5902L10.0946 19.0702L8.07961 15.5801Z",
    fill: "#FF9780"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4056 9.59995C30.2556 9.77995 30.7456 10.4899 26.2656 2.74995C27.1338 2.53482 28.0481 2.60317 28.8746 2.945C29.7012 3.28682 30.3967 3.88418 30.8593 4.64968C31.322 5.41518 31.5275 6.30865 31.4459 7.19936C31.3642 8.09008 30.9997 8.9313 30.4056 9.59995Z",
    fill: "#FF9780"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.014 2.87988L29.054 11.6099L23.514 14.1099L19.084 6.42988L24.014 2.87988Z",
    fill: "#FF9780"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4648 20C18.1217 20 19.4648 18.6569 19.4648 17C19.4648 15.3431 18.1217 14 16.4648 14C14.808 14 13.4648 15.3431 13.4648 17C13.4648 18.6569 14.808 20 16.4648 20Z",
    fill: "#FF9780"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4648 17C17.4648 17.2652 17.3595 17.5196 17.172 17.7071C16.9844 17.8946 16.7301 18 16.4648 18C16.1996 18 15.9453 17.8946 15.7577 17.7071C15.5702 17.5196 15.4648 17.2652 15.4648 17C15.4648 16.7348 15.5702 16.4804 15.7577 16.2929C15.9453 16.1054 16.1996 16 16.4648 16C16.7301 16 16.9844 16.1054 17.172 16.2929C17.3595 16.4804 17.4648 16.7348 17.4648 17Z",
    fill: "#FF613D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindIcn);
export default __webpack_public_path__ + "static/media/Find Icn.513c1497.svg";
export { ForwardRef as ReactComponent };